import {endpoints} from './endpoints'
import request from '../helpers/request'

export function searchTrackingHistorial(data){
	return new Promise((resolve, reject) => {
    request({
      url: endpoints.searchTrackingByDate,
      method: 'post',
      data
    })
		  .then(async function (response) {
		    resolve(response)
		  })
		  .catch(function (error) {
		    reject(error)
		  });
	})
}
export function activateTrackingRemote(data){
	return new Promise((resolve, reject) => {
    request({
      url: endpoints.activateTracking,
      method: 'post',
      data
    })
		  .then(function (response) {
		    resolve(response)
		  })
		  .catch(function (error) {
		    reject(error)
		  });
	})
}